module.exports = __webpack_public_path__ + "media/assets/images/icon_wechat-e5c976a8310a4f38e565fc9e02a63c15.png";